/**
 * Copyright © Veeam Software Group GmbH.
 */

import { EPeriod } from '@veeam-vspc/models/web-controllers';

export type RpoPeriod = EPeriod;
export const RpoPeriod = EPeriod;
